import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EGeneralRatingActionTypes {
  SetRating = 'NEW_REVIEW/GENERAL_RATING/SET',
}

type TSetGeneralRatingTypes = ITypedReduxAction<EGeneralRatingActionTypes.SetRating, number>;

/**
 * Redux action, который записывает в store общий рейтинг нового отзыва
 * @param rating number
 */
export const setGeneralRating: (rating: number) => TSetGeneralRatingTypes = actionGenerator<
  EGeneralRatingActionTypes.SetRating,
  number
>(EGeneralRatingActionTypes.SetRating);

export type TSetGeneralRating = TSetGeneralRatingTypes;
